import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import LoanCalculatorModal from './loan_calculator_modal';
import DragNDropModal from './drag_n_drop_modal';
import LoanChallenge1Dataset from './Datasets/loan_challenge1_dataset';
import LoanChallenge1InitialText from '../../dragNDropText/loan_challenge1_initial_text';
import LoanChallenge1HintsText from './text/loan_challenge1_hints_text';
import LoanChallenge1ResultsText from './text/loan_challenge1_results_text';
import LoanChallenge2Dataset from './Datasets/loan_challenge2_dataset';
import LoanChallenge2InitialText from '../../dragNDropText/loan_challenge2_initial_text';
import LoanChallenge2HintsText from './text/loan_challenge2_hints_text';
import { createColumnArray } from '../../objects/DragNDrop/createColumnArray_function';
import { calcColumnScore } from '../../objects/DragNDrop/calcColumnScore_function';
import { createResultsArray } from './objects/createResultsArray_function';
import ExtraCreditConfigFile from './Datasets/extra_credit_config_file';
import {dragNDropBefore} from '../../objects/DragNDrop/drag_n_drop_before_function';

class LearningAboutLoans extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            callRender: false,
            openCalculatorSw: false,
            openSw: false,
        }
        this.dragNDrop = {};
        this.hintTable = [];
        this.currentStatus = "";
        this.calculatorStatus = "DisplayCalculator";
        this.challenge1Score = 0;
        this.challenge2Score = 0;
        this.averageScore = 0;
        this.displayAlert = false;
        this.modalMessage = "";
        this.col1Text = "";
        this.freezeFlag = false;
        this.tableObject = [];
        this.tableNbrRows = 0;
        this.calculateOnly = false;
        this.hintNbr = 0;
    }
       
    openLoanCalculator () {
         this.calculatorStatus = "OpenCalculator"
        if ( this.currentStatus === "OpenChallenge1" || 
                this.currentStatus === "OpenChallenge2") {
             this.calculateOnly  = true;
        }else{
             this.calculateOnly  = false;
        }
        this.setState({openCalculatorSw: true});
    };

    closeLoanCalculator() {
         this.calculatorStatus = "CloseCalculator";
        if ( this.currentStatus !== "OpenChallenge1" &&
             this.currentStatus !== "OpenChallenge2") {
              this.currentStatus = "DisplayChallenge1"
        }
        this.setState({openCalculatorSw: false});
    }

    openLoanChallenge1() {
         this.currentStatus = "OpenChallenge1";
        this.dragNDrop  = dragNDropBefore("Categorize the Loan Parameters",
            LoanChallenge1InitialText, "", "DoneCalculator", "Loan", LoanChallenge1Dataset,
            "LoanChallenge1", 1);
        this.hintTable  = LoanChallenge1HintsText; 
        this.setState({openSw: true});
                  
    }

    closeLoanChallenge1() {
         this.currentStatus = "DisplayChallenge1";
         this.freezeFlag = false;
        this.setState({openSw: false});
    }

    saveLoanChallenge1() {
        var columnArray=createColumnArray( this.dragNDrop.cookieNamePfx, 5);
         this.challenge1Score = calcColumnScore(columnArray);
        if ( this.challenge1Score > 85) {
             this.modalMessage = "";
             sessionStorage.setItem("loanChallenge1Score",  this.challenge1Score);
             this.dragNDrop.introText = LoanChallenge1ResultsText;
             this.tableObject=createResultsArray(columnArray);
             this.col1Text=["Calculated Amount"];
             this.tableNbrRows = 1;
             this.dragNDrop.buttonType = "Continue";
             this.freezeFlag = true;
        } else {
             this.modalMessage= "Not quite right... Try again.";
             this.displayAlert = true;
            if (this.hintNbr <  this.hintTable.length){
                this.hintNbr += 1;
            }
        }   
        this.setState({callRender: true});
    }

    finishChallenge1() {
        this.currentStatus = "DisplayChallenge2";
        this.setState({openSw: false});
    }

    openLoanChallenge2() {
        this.currentStatus = "OpenChallenge2"
        this.dragNDrop  = dragNDropBefore ("Determine Which Loan Requests Should Be Approved", 
            LoanChallenge2InitialText, "", "DoneCalculator", "Loan", LoanChallenge2Dataset, "loanChallenge2", 
            "");
       
        this.freezeFlag = false; 
        this.tableNbrRows = 0;
        this.tableObject = [];
        this.hintTable  = LoanChallenge2HintsText;
        this.setState({openSw: true});
    }

    closeLoanChallenge2() {
        this.currentStatus = "DisplayChallenge2"
        this.setState({openSw: false});
    }

    saveLoanChallenge2() {
        var columnArray=createColumnArray( this.dragNDrop.cookieNamePfx, 3);
        if (columnArray[0].items.length !== 0) {
             this.modalMessage = 
                "Drag all items from the Loan Request to the Approve or Denied columns."
             this.setState({callRender: !this.state.callRender});
        }else{
            this.challenge2Score = calcColumnScore(columnArray);
            if ( this.challenge2Score >= 85) {
               this.finishLoans();
            } else {
                 this.modalMessage= "Not quite right... Try again."
                 this.displayAlert = true;
                if (this.hintNbr <  this.hintTable.length){
                    this.hintNbr+=1;
                }
                this.setState({callRender: !this.state.callRender});
            }
        }
    }
   
    getLoanChallenge1Score() {
        var challenge1Score = parseFloat(sessionStorage.getItem("loanChallenge1Score"));
        if (!isNaN(challenge1Score) &&  this.currentStatus === "") {
            this.currentStatus = "DisplayChallenge2" 
            this.challenge1Score = challenge1Score;
        }
    }
    
    closeAlert(){
         this.displayAlert = false;
        this.setState({callRender: true});
    }
    
    
    render() {
        this.getLoanChallenge1Score();
              
               
    return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" scrollable="true"
            animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Extra Credit - Learning About Loans</Modal.Title> 
          </Modal.Header>
          <Modal.Body>
           
                { this.calculatorStatus === "DisplayCalculator" ?
                    <span>
                        <div className="mt-2, mx-4">
                            <p>Click on the "Loan Calculator" button to learn how the loan parameters 
                            impact the amount that you must pay each month and the total amount you will 
                            pay.  Once you understand the basic concepts, you can tackle the
                            challenge exercises that will be available.</p>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-2" 
                                onClick ={()=> this.openLoanCalculator()}>
                                    Loan Calculator
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }
                { this.calculatorStatus === "OpenCalculator" ?
                    <LoanCalculatorModal show={this.state.openCalculatorSw} 
                        loanChallenges={true}
                        exerciseButtons={false}
                        onClose={() => this.closeLoanCalculator()} 
                        calculatorSw ={ this.calculateOnly }/>
                :
                    <div></div>
                }
                { this.currentStatus === "DisplayChallenge1" ?
                    <span>
                         <div className="m-4" >
                             <p>Now that you've had a chance to experiment with the loan calculator,
                                click on the "Challenge #1" button to check your understanding of
                                how the key loan factors affect the payment amounts.</p>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-4" 
                            onClick ={()=> this.openLoanChallenge1()}>
                                Loan Challenge #1
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }

                { this.currentStatus === "OpenChallenge1" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeLoanChallenge1()} 
                        onSave={() => this.saveLoanChallenge1()}
                        onCalculator={() => this.openLoanCalculator()}
                        onContinue={() => this.finishChallenge1()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={ this.dragNDrop.inputData}
                        modalSize={ this.dragNDrop.modalSize}
                        modalTitle={ this.dragNDrop.modalTitle}
                        buttonType={ this.dragNDrop.buttonType}
                        calcType={ this.dragNDrop.calculatorType}
                        introText={ this.dragNDrop.introText}
                        cookieNamePfx={ this.dragNDrop.cookieNamePfx}
                        maxNbr={ this.dragNDrop.maxNbrPerColumn}
                        message={ this.modalMessage}
                        tableNbrRows={ this.tableNbrRows}
                        tableCol1Text={ this.col1Text}
                        tableObjectRow={ this.tableObject}
                        freezeFlag={ this.freezeFlag}
                        hintTable={ this.hintTable }
                        hintNbr={this.hintNbr}
                        displayAlert={ this.displayAlert}

                        />
                :
                    <div></div>
                }

                { this.currentStatus  === "DisplayChallenge2" ?
                    <span>
                        <p className="mt-4 ml-4 p-2">Congratulations, you have successfully completed 
                            the first challenge, would you like to try another one?  When you successfully
                            complete the second challenge, you will earn points for your game. 
                        </p>
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-6" 
                                onClick ={()=> this.openLoanChallenge2()}>
                                    Challenge #2
                            </button>
                        </div>
                    </span> 
                :
                    <div></div>
                }
                   
                { this.currentStatus === "OpenChallenge2" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeLoanChallenge2()} 
                        onSave={() => this.saveLoanChallenge2()}
                        onCalculator={() => this.openLoanCalculator()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={ this.dragNDrop.inputData}
                        modalSize={ this.dragNDrop.modalSize}
                        modalTitle={ this.dragNDrop.modalTitle}
                        introText={ this.dragNDrop.introText}
                        cookieNamePfx={ this.dragNDrop.cookieNamePfx}
                        buttonType={ this.dragNDrop.buttonType}
                        calcType={ this.dragNDrop.calculatorType}
                        message={ this.modalMessage}
                        hintTable={ this.hintTable }
                        hintNbr={this.hintNbr}
                        displayAlert={ this.displayAlert}
                        />
                    :
                        <div></div>
                    }
                </Modal.Body>
          <Modal.Footer className="text-right">
                <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                    alt="train"/>
                <Button variant="secondary"   onClick={() => this.props.onClose()}>
                    Close
                </Button>
          </Modal.Footer>
          </Modal>
       </>
    }

    finishLoans() {
        this.averageScore = (+ this.challenge1Score + + this.challenge2Score) / 2; 
        this.calculateLoanPoints();
        sessionStorage.setItem("previousExtraCreditProcess", "Learning About Loans"); 
        this.props.onCompleted(); 
    }

    calculateLoanPoints(){

        var earnedAmt = 0;
        let processName = "LearningAboutLoans";
        let earningsObj = ExtraCreditConfigFile.exercises.find(elem => elem.category === processName);
        earnedAmt = (+earningsObj.amt).toFixed(2);
        const loansObj = {processName: processName, score: this.averageScore,
            assetType: earningsObj.type,  amount: earnedAmt, level: earningsObj.level};
        sessionStorage.setItem("extraCreditCompleted", JSON.stringify(loansObj));
    }
}

export default LearningAboutLoans;